import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appUppercase]',
  standalone: true
})
export class UppercaseDirective {

  @Input() appUppercase: boolean = true;

  @HostListener('input', ['$event']) onInput(event: any) {
    console.log(this.appUppercase)
    if (this.appUppercase === true) {
      event.target.value = event.target.value.toUpperCase();
    }
  } 


}
